import i18n from 'helpers/i18n';
import messages from './messages';
import { bigCommerceURL } from 'constants/environmentVariables';
import { convertToLocal } from 'helpers/date/localTimezone';
import { Button } from '@teachstonellc/component-library';

function ExpiredRenewable({
  expires_at,
  two_week_extension_sku
}: {
  expires_at: string;
  two_week_extension_sku?: string | null;
}) {
  const productUrl = two_week_extension_sku
    ? `${bigCommerceURL}/cart.php?action=add&sku=${two_week_extension_sku}`
    : `${bigCommerceURL}/two-week-extension`;
  return (
    <>
      <p
        className="text-center text-lg"
        dangerouslySetInnerHTML={{
          __html: i18n.ft(messages.expiredRenewable, {
            date: convertToLocal(expires_at)
          })
        }}
      ></p>
      <div className="grid w-full mt-auto mb-2">
        <Button
          as="a"
          href={productUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="primary"
          className="mt-5 justify-self-center"
        >
          {i18n.ft(messages.purchaseExtension)}
        </Button>
      </div>
    </>
  );
}

export default ExpiredRenewable;
